export default {
  Register(importedData, onsuccess,onfailed,self){

    let registerImport = new FormData();
    registerImport.append('import_type', importedData.importType)
    registerImport.append('file', importedData.file)
    
    if (importedData.importType === 'asset'){
      registerImport.append('site', importedData.site)
      registerImport.append('location', importedData.location)
    }

    return {
        data : {
          ImportType  : importedData.importType,
          File        : importedData.file,
          Data        : registerImport
        },
        AuthorizationToken  : self.props.UserReducer.token,
        onfailed            : onfailed,
        onsuccess           : onsuccess,
        self:self,
    }
  },
  ReadAsMaster(action, self, ReadMasterSuccess, ReadMasterFailed) {
    return {
      data : {
        AuthorizationToken : self.props.UserReducer.token,
      },
      action : action,
      self: self,
      onsuccess : ReadMasterSuccess,
      onfailed : ReadMasterFailed,
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/master/import/helper/request.props.js